import { http } from "@/utils/http";
import qs from "qs";

/** 发送统计数据 */
export const sendReportData = (data: object) => {
  return http.request<BaseResult>("post", "/report/data", {
    data,
    timeout: 0
  });
};

/** 获取报表信息 */
export const getReport = (data: object) => {
  return http.request<BaseResult>(
    "get",
    `/report/getReport?${qs.stringify(data)}`
  );
};

/** 下载报表 */
export const getReportExcel = (data: object) => {
  return http.request<Blob>(
    "get",
    `/report/getReportExcel?${qs.stringify(data)}`,
    { responseType: "blob" }
  );
};

/** 协助日志 获取日志列表 */
export const getAssistLogListApi = (data: object) => {
  return http.request<BaseResult>(
    "get",
    `/diagnosticLog/v1/findDiagnosticAssistanceList?${qs.stringify(data)}`
  );
};

/** 协助日志 下载日志文件 */
export const downloadAssistLogFileApi = (id: number) => {
  return http.request<Blob>("get", `/diagnosticLog/v1/download/${id}`, {
    responseType: "blob"
  });
};

/** 协助日志 已读详情 */
export const readAssistReplyLogApi = (id: number) => {
  return http.request<BaseResult>("post", `/diagnosticLog/v1/readAsk/${id}`);
};

/** 协助日志 获取回复列表 */
export const getAssistReplyListApi = (id: number) => {
  return http.request<BaseResult>(
    "get",
    `/diagnosticLog/v1/getDiagnosticReply/${id}`
  );
};

/** 协助日志 回复消息 */
export const replyAssistReplyLogApi = (data: object) => {
  return http.request<BaseResult>("post", `/diagnosticLog/v1/reply`, { data });
};

/** 协助日志 回复消息 */
export const updateAssistLogStatusApi = (data: object) => {
  return http.request<BaseResult>("post", `/diagnosticLog/v1/updateStatus`, {
    data
  });
};

/** 协助日志 检测是否有新回复 */
export const detectionNewAssistReply = () => {
  return http.request<BaseResult<boolean>>(
    "get",
    `/diagnosticLog/v1/isDiagAssistNewAsk`
  );
};

/** 刷写日志 获取日志列表 */
export const getFlashLogListApi = (data: object) => {
  return http.request<BaseResult>(
    "get",
    `/scriptFlash/v1/findScriptFlashList?${qs.stringify(data)}`
  );
};
